export default "__VITE_ASSET__DEnciiTp__"